<template>
	<div v-if="cart.cpu" class="starter-pc">
		<general-modal />
		<hero-section
			:which="which"
			@buy-now="buyNow"
			@click-quoted-payment="paymentQuoteClicked"
			@see-specs="onSeeSpecs"
		/>
		<creator-pc-description v-if="$route.name == 'creator-pc'" />
		<streamer-quotes v-if="$route.name == 'streaming-pc'" />
		<games-fps-estimation />
		<comparison-banner :which="which" />
		<key-features />
		<h1-case-features v-if="which == 'h1-mini-pc'" />
		<creator-nvidia v-if="which == 'creator-pc'" />
		<external-monitor-specs v-if="which.includes('starter-pc')" :landing-page-index="11" />
		<external-monitor-specs v-if="which == 'streaming-pc'" :landing-page-index="12" />
		<buy-options
			:which="which"
			@buy-now="buyNow"
			@click-quoted-payment="paymentQuoteClicked"
		/>
		<hr>
		<starter-pc-reviews v-if="which != 'h1-mini-pc'"/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { heapAnalytics } from "@u/mixins.js";
import HelpersMixin from "./helpers-mixin";
import HeroSection from "./hero-section";
import GamesFpsEstimation from "./games-fps-estimation/";
import ComparisonBanner from "./comparison-banner";
import KeyFeatures from "./key-features";
import BuyOptions from "./buy-options";
import StreamerQuotes from "./streaming-pc/streamer-quotes";
import StarterPcReviews from "./starter-pc-reviews";
import CreatorPcDescription from "./creator-pc/description";
import ExternalMonitorSpecs from "./external-specs";
import CreatorNvidia from "./creator-pc/creator-nvidia";
import H1CaseFeatures from "./h1-mini-pc/h1-case-features";
import { gtmMap, gtmTrigger, gtmTrack } from "@/util/gtm";

export default {
	name: "StarterPC",
	components: {
		CreatorPcDescription,
		ExternalMonitorSpecs,
		HeroSection,
		GamesFpsEstimation,
		ComparisonBanner,
		KeyFeatures,
		BuyOptions,
		StreamerQuotes,
		StarterPcReviews,
		CreatorNvidia,
		H1CaseFeatures
	},
	mixins: [
		heapAnalytics,
		HelpersMixin
	],
	computed: {
		...mapGetters({
			trackStarterType: "StarterPc/getTrackType",
			reviewCount: "StarterPc/reviewCount",
			userCurrency: "userCurrency"
		}),
		gtmEcommmercePrebuild() {
			return gtmMap.starterSeriesPrebuildToProduct(this.builds[this.buildsIndex], this.cart.case);
		}
	},
	watch: {
		"cart.cpu"(cpu) {
			this.setShowLoading(cpu ? false : true);
		},
		buildsIndex(current, previous) {
			if (previous != null) {
				this.fetchReviews();
			}
		},
		builds(prebuilds) {
			const prebuildName = prebuilds[this.buildsIndex].name;
			gtmTrack.prebuildVisited(prebuildName);
		}
	},
	created() {
		this.setShowLoading(true);
		this.$store.dispatch("StarterPc/getData", {
			which: this.$route.meta.group,
			route: this.which
		});
	},
	methods: {
		...mapActions({
			setShowLoading: "Application/setShowLoading"
		}),
		fetchReviews() {
			this.$store.dispatch("StarterPc/setPage", 1);

			const shouldCleanOldReviews = true;
			this.$store.dispatch("StarterPc/getReviews", shouldCleanOldReviews);
		},
		buyNow(trackingOptions) {
			this.trackAll(`Client: Click ${this.trackStarterType} BuyNow`, trackingOptions);
			gtmTrigger.addToCart([this.gtmEcommmercePrebuild], trackingOptions.page_location, this.userCurrency);

			if (!this.POS_MODE) {
				this.$router.push({ name: `${this.which}-accessories` });
			} else {
				this.$modal.show("general", {
					button: "Okay",
					content: `\
                        <h5 style="margin-bottom: 3px; font-family: 'Akkurat-Bold';">Looking to buy a Starter PC?</h5>
                        Just find an NZXT staff member or go to a checkout station to take home your Starter PC today. <br>
                        <h5 style="margin-bottom: 3px; font-family: 'Akkurat-Bold';">If you don't want to carry one home, no worries.</h5>
                        Our staff can order your Starter PC and have it shipped within 24 hours!
                    `,
					contentClass: "text-left",
					showCloseButton: false
				});
			}
		},
		paymentQuoteClicked(position) {
			gtmTrigger.quotedPaymentClick(this.gtmEcommmercePrebuild, position);
		},
		onSeeSpecs() {
			gtmTrack.prebuildShowSpecs();
			gtmTrigger.showSpecs(this.gtmEcommmercePrebuild);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.starter-pc {
    background: $white;

    hr {
        border-top: 1px solid #dadde0;
        margin: 0;
    }
}
</style>
